module.exports = __webpack_public_path__ + "img/COMBO HEART PURPLE.f65c84a.svg";